var _excluded = ["children", "className", "size", "noMargin", "noPadding", "noPaddingTop", "extraPaddingTop", "extraMarginBottom", "whiteBg", "overlappingFullWidthImage"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
/**
 * Status: *in progress*
 * Category: Misc
 *
 * There are three main container widths: small, medium and large. Body text should be in a small container to reduce line width and make reading easier.
 */
var Container = function Container(_ref) {
  var _classnames;
  var children = _ref.children,
    className = _ref.className,
    size = _ref.size,
    noMargin = _ref.noMargin,
    noPadding = _ref.noPadding,
    noPaddingTop = _ref.noPaddingTop,
    extraPaddingTop = _ref.extraPaddingTop,
    extraMarginBottom = _ref.extraMarginBottom,
    whiteBg = _ref.whiteBg,
    overlappingFullWidthImage = _ref.overlappingFullWidthImage,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classnames('container', className, (_classnames = {}, _defineProperty(_classnames, "container--".concat(size), size), _defineProperty(_classnames, 'container--no-margin', noMargin), _defineProperty(_classnames, 'container--no-padding', noPadding), _defineProperty(_classnames, 'container--no-padding-top', noPaddingTop), _defineProperty(_classnames, 'container--extra-padding-top', extraPaddingTop), _defineProperty(_classnames, 'container--extra-margin-bottom', extraMarginBottom), _defineProperty(_classnames, 'container--white-bg', whiteBg), _defineProperty(_classnames, 'container--overlapping-full-width-image', overlappingFullWidthImage), _classnames))
  }, rest), children);
};
Container.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  noMargin: PropTypes.bool,
  noPadding: PropTypes.bool,
  noPaddingTop: PropTypes.bool,
  extraPaddingTop: PropTypes.bool,
  extraMarginBottom: PropTypes.bool,
  whiteBg: PropTypes.bool,
  overlappingFullWidthImage: PropTypes.bool
};
export default Container;